import { IBusinessAttribute, SelectorTypes } from '@site-mate/sitemate-global-shared';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface WorkspaceSetupForm {
  workspaceName: string;
  businessAttributes: { [key in SelectorTypes]: IBusinessAttribute | null };
}

interface WorkspaceSetupStore {
  workspaceSetupStep: WorkspaceSetupSteps;
  workspaceSetupForm: WorkspaceSetupForm;
  setWorkspaceSetupStep: (arg0: WorkspaceSetupSteps) => void;
  setWorkspaceSetupForm: (arg0: WorkspaceSetupForm) => void;
  clearWorkspaceSetupStore: () => void;
}

export enum WorkspaceSetupSteps {
  WorkspaceName = 'WorkspaceName',
  WorkspaceBranding = 'WorkspaceBranding',
  BusinessAttributesSelector = 'BusinessAttributesSelector',
  WelcomeModal = 'WelcomeModal',
  Complete = 'Complete',
}

export const useWorkspaceSetupStore = create<WorkspaceSetupStore>()(
  persist(
    (set) => ({
      workspaceSetupStep: WorkspaceSetupSteps.WorkspaceName,
      workspaceSetupForm: {
        workspaceName: '',
        businessAttributes: { [SelectorTypes.Vertical]: null, [SelectorTypes.Role]: null, [SelectorTypes.Discipline]: null },
      },
      setWorkspaceSetupStep: (workspaceSetupStep: WorkspaceSetupSteps) => set(() => ({ workspaceSetupStep })),
      setWorkspaceSetupForm: (workspaceSetupForm: WorkspaceSetupForm) => set(() => ({ workspaceSetupForm })),
      clearWorkspaceSetupStore: () => {
        localStorage.removeItem('gb-workspace-setup');
      },
    }),
    {
      name: 'gb-workspace-setup',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
